import base from './base';

export default {
  create(formData) {
    return base.postFormData('/register', formData);
  },
}
